import React, { useMemo, useState } from "react";
import { DataField } from "shared/providers/types";
import CheckboxListWithSearch from "src/components/base/CheckboxListWithSearch";

interface FieldListProps {
  items: DataField[],
  selectedFieldNames: string[],
  onChange: (items: string[]) => void,
  searchPlaceholder: string,
  disabled?: boolean,
}

export const FieldList: React.FC<FieldListProps> = (props) => {
  const { items, searchPlaceholder = 'Type to search', selectedFieldNames, disabled, onChange } = props;
  const [filter, setFilter] = useState('');

  const { listItems, allChecked } = useMemo(() => {
    const selectedNameSet = new Set(selectedFieldNames);
    const listItems: any[] = items
      .filter((item) => !filter || item.label.toLowerCase().includes(filter.toLowerCase()))
      .map((item) => ({
        key: item.name,
        text: item.label,
        selected: selectedNameSet.has(item.name),
      }));
    const allChecked = items.every((item) => selectedNameSet.has(item.name));
    return { listItems, allChecked };
  }, [selectedFieldNames, items, filter]);

  const handleAllChecked = (checked: boolean) => {
    checked
      ? onChange?.(items.map((item) => item.name))
      : onChange?.([]);
  }

  const handleItemChecked = (checked: boolean, item: any) => {
    if (checked) {
      onChange?.([...selectedFieldNames, item.key]);
    } else {
      onChange?.(selectedFieldNames.filter((fieldName) => fieldName !== item.key));
    }
  }

  return (
    <CheckboxListWithSearch
      filterPlaceholder={searchPlaceholder}
      listItems={listItems as never[]}
      disabled={disabled}
      areAllChecked={allChecked}
      onAllChecked={(checked: boolean) => handleAllChecked(checked)}
      onItemChecked={(checked: boolean, item: any) => handleItemChecked(checked, item)}
      onFilterChanged={(filterString: string) => setFilter(filterString)}
    />
  )
}
